import React, { useState, useEffect } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from "reactstrap";
import Aos from "aos";
import "./GoogleReviews.css";

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 800 });
  }, []);

  useEffect(() => {
    let cancelled = false;
    const source = axios.CancelToken.source();

    async function fetchReviews() {
      try {
        setLoading(true);
        const res = await axios.get(
          "https://eksiogluhukukofisi.pythonanywhere.com/api/reviews/",
          { cancelToken: source.token },
        );
        if (!cancelled) {
          setReviews(Array.isArray(res.data) ? res.data : []);
          setError(null);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          setError(err);

          console.error("Google Reviews:", err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchReviews();
    return () => {
      cancelled = true;
      source.cancel("GoogleReviews unmounted");
    };
  }, []);

  const recentReviews = [...reviews]
    .sort((a, b) => new Date(b.review_date) - new Date(a.review_date))
    .slice(0, 8);

  // Marquee için içeriği iki kez çoğalt (sonsuz akış)
  const looped = [...recentReviews, ...recentReviews];

  // Mobilde slider, desktop’ta marquee
  const scrollDuration = isMobile ? "45s" : "20s";

  // Mobil slider ayarları
  const mobileSettings = {
    className: "reviews-slider gr-slider",
    dots: true,
    infinite: true,
    arrows: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    cssEase: "ease-in-out",
  };

  return (
    <div className="gv-reviews google-reviews">
      <Container data-aos="fade-up">
        <h2 className="google-reviews-title">GOOGLE YORUMLARI</h2>

        {loading && <div>Yükleniyor…</div>}

        {!loading && recentReviews.length > 0 && (
          <>
            {isMobile ? (
              <Slider {...mobileSettings}>
                {recentReviews.map((review) => (
                  <div key={review.id} className="gr-slide">
                    <div className="review-card">
                      <div className="review-header">
                        <img
                          src={review.profile_photo_url}
                          alt={review.author_name}
                          className="review-avatar"
                          loading="lazy"
                        />
                        <div>
                          <h3 className="review-author">
                            {review.author_name}
                          </h3>
                          <p className="review-date">
                            {new Date(review.review_date).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                      <div className="review-rating">⭐⭐⭐⭐⭐</div>
                      <p className="review-text">{review.text}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div
                className="marquee"
                style={{ ["--scroll-duration"]: scrollDuration }}
              >
                <div className="marquee__track">
                  {looped.map((review, idx) => (
                    <div key={`${review.id}-${idx}`} className="marquee__item">
                      <div className="review-card">
                        <div className="review-header">
                          <img
                            src={review.profile_photo_url}
                            alt={review.author_name}
                            className="review-avatar"
                            loading="lazy"
                          />
                          <div>
                            <h3 className="review-author">
                              {review.author_name}
                            </h3>
                            <p className="review-date">
                              {new Date(
                                review.review_date,
                              ).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                        <div className="review-rating">⭐⭐⭐⭐⭐</div>
                        <p className="review-text">{review.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        <div
          className="reviews-button"
          style={{ marginTop: isMobile ? "40px" : "" }}
        >
          <a
            className="btn-google font-sans font-bold"
            target="_blank"
            rel="noreferrer"
            href="https://www.google.com/maps/place/Ek%C5%9Fio%C4%9Flu+Hukuk/@40.9177709,29.1771701,17z/data=!4m8!3m7!1s0x14cad19b832a9b95:0x7eed51a12e72685b!8m2!3d40.9177669!4d29.179745!9m1!1b1!16s%2Fg%2F11s88yfz0x?entry=ttu"
          >
            Tüm Yorumları Görüntüle
          </a>
        </div>
      </Container>
    </div>
  );
};

export default GoogleReviews;
